var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 12.7894 12.7894",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.0394 7.83127C11.0578 8.10655 10.0205 8.11557 9.03421 7.85741C8.0479 7.59924 7.14808 7.08321 6.42716 6.36229C5.70624 5.64137 5.19021 4.74155 4.93204 3.75524C4.67388 2.76894 4.68291 1.73169 4.95818 0.750018C3.99035 1.0194 3.10998 1.53766 2.40477 2.25316C1.69956 2.96867 1.19412 3.85646 0.9388 4.8281C0.683476 5.79973 0.687179 6.82131 0.949539 7.79107C1.2119 8.76084 1.72376 9.64494 2.43414 10.3553C3.14451 11.0657 4.02861 11.5776 4.99838 11.8399C5.96814 12.1023 6.98971 12.106 7.96135 11.8506C8.93299 11.5953 9.82078 11.0899 10.5363 10.3847C11.2518 9.67947 11.77 8.7991 12.0394 7.83127Z",
    stroke: "var(--stroke-0, #9698A3)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoon);
export default __webpack_public_path__ + "static/media/moon.39c7e7fbed4135c446e01aded4e004e7.svg";
export { ForwardRef as ReactComponent };